module.exports = __webpack_public_path__ + "img/Background.d2c2c6f5.png";